export default __webpack_public_path__ + "static/media/member-icon.20432906.svg";